<template>
  <footer class="bg-surface-3 border-t border-line py-2.5 mt-auto">
    <div class="container mx-auto px-4">
      <div class="text-center text-sm text-faint">
        <p class="mb-0.5 text-xs">
          {{ $t('footer-designed-by') }}
          <a href="https://dimensionalsys.com" target="_blank" rel="noopener" class="text-ink-3 hover:underline">Dimensional Sys.</a>
        </p>
        <p class="text-xs">
          <span>© {{ new Date().getFullYear() }} <a href="https://daytradercanada.com/" target="_blank" rel="noopener" class="text-ink-3 hover:underline">DayTrader Canada.</a> {{ $t('footer-rights-reserved') }}</span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
footer {
  margin-top: auto;
}
</style> 